import React from 'react'
// import backgroundImage from '../../Assets/bg.png'
import {connect} from 'react-redux'
import * as actionTypes from '../../Action/Index'
import queryString from 'query-string';
import Loader from 'react-loader-advanced';
import Spinner from 'react-bootstrap/Spinner';
import {Button} from 'react-bootstrap';
import classes from './VerifiedEmailScreen.module.css';
import {Col, Row, Form,Card} from 'react-bootstrap';
import Servererror from '../commonComponents/NetworkError/ServerError/Servererror'
class VerifiedEmailScreen extends React.Component{
    state={
        token:'',
        email:'',
        type:""      
    }

    componentWillMount=()=>{
        let url=this.props.location.search;
        if(localStorage.getItem('userToken')!=null && localStorage.getItem('userToken')!="" && localStorage.getItem('userToken')!=undefined){
          this.props.history.push('/interview')
        }
        else{
          if(url!==''){
            let params = queryString.parse(url);
            let token=params.token
            let emailExtract=token.split('$');
            let type = emailExtract[2];
            this.setState({token:token,email:emailExtract[1],type:type},()=>{
              if(this.state.type=="CN"){
                this.props.onVerifyEmail(this.state.token);
              }
              else{
                this.props.history.push({pathname:'/'});
              }
            })
         }else{
           this.props.history.push({pathname:'/'});
         }
        }
       
  }
  backToLogin=()=>{
    this.props.history.push({
        pathname:'/login'
       });
 }
    render(){
        return(
          <div className={classes.Background}>
            <Card className={classes.body_interviewer} >
            <Card.Body>
            <div className={classes.cardbody}>
            <Loader show={this.props.loader} message={ <Spinner animation="border" role="status"></Spinner> } style={{height:"auto"}}
            foregroundStyle={{color: '#fbb03b'}}
            backgroundStyle={{backgroundColor: 'white'}}
            >   {this.props.VerifyEmailNetworkStatus==false?<>
                { this.props.verifyEmailStatus==true?
                <div className={classes.textCenter}>
                  <h2>Welcome to FoxMatrix</h2> 
                  <p >Your account <span style={{fontWeight:"bold"}}>{this.state.email}</span> has been activated. Click below to login.</p>
                    <Button className = {classes.Button} variant="warning" onClick = {()=>this.backToLogin()}>Go to Login</Button>
                
                </div>
                :<div className={classes.textCenter}>
                <h4 className={classes.ServerError}>{this.props.errorMsgVerifyEmail}</h4>

                    <Button className = {classes.Button} style={{marginTop: '5px'}} variant="warning" onClick = {()=>this.backToLogin()}>Go to Login</Button>
               
               </div>
                }
               </> :<Servererror msg="Our servers are not responding at the moment, Please bear with us." marginTop = "0%" width="20%"/>}
            </Loader>
            </div>
            </Card.Body>
            </Card>
            </div>
     )
    }
}


const mapStateToProps = state => {
    return{
      verifyEmailStatus: state.employeeReducer.verifyEmailStatus,
      loader:state.employeeReducer.loader,
      verifyInterviewerEmailStatus : state.employeeReducer.verifyInterviewerEmailStatus,
      errorMsgVerifyEmail:state.employeeReducer.errorMsgVerifyEmail,
      VerifyEmailNetworkStatus:state.employeeReducer.VerifyEmailNetworkStatus
    }
  }
  
const mapDispatchToProps = dispatch => {
    return{
      onVerifyEmail: (token) => dispatch(actionTypes.verifyEmail(token)),
    }
  }
export default connect(mapStateToProps,mapDispatchToProps)(VerifiedEmailScreen);